import { fetchRazno } from '../fetch/documents';
import { createReducer } from './createReducer';
const raznoSlice = createReducer("razno", fetchRazno);


export const selectRazno = (state) => state.razno.value
export const selectLoadingRazno = (state) => state.razno.isLoading

export const {} = raznoSlice.actions

export default raznoSlice.reducer

